import type { RoommateCandidate, RoommatePreferences } from '../types/housing'

export const defaultPreferences: RoommatePreferences = {
  budgetMax: 600000,
  moveIn: '2026-09-01',
  kind: 'Shared apartment',
  roommateCount: 2,
  sleep: 'Balanced',
  tidiness: 'Tidy',
  noise: 'Quiet',
  study: 'Mixed',
  smoking: 'No smoking',
  guests: 'Sometimes',
  sharedShopping: true,
}

export const candidates: RoommateCandidate[] = [
  {
    id: 'rm-1',
    displayName: 'Chidera N.',
    initials: 'CN',
    programme: 'B.Sc. Accounting',
    level: '300 Level',
    bio: 'Looking for a quiet flat within walking distance of Akoka. I study at home most evenings and cook for myself.',
    contactShared: false,
    preferences: {
      budgetMax: 580000,
      moveIn: '2026-09-01',
      kind: 'Shared apartment',
      roommateCount: 2,
      sleep: 'Balanced',
      tidiness: 'Tidy',
      noise: 'Quiet',
      study: 'At home',
      smoking: 'No smoking',
      guests: 'Rarely',
      sharedShopping: true,
    },
  },
  {
    id: 'rm-2',
    displayName: 'Tolu A.',
    initials: 'TA',
    programme: 'B.Eng. Civil Engineering',
    level: '400 Level',
    bio: 'Final year, mostly on site or in the library. Happy to share a two-bedroom with someone tidy.',
    contactShared: false,
    preferences: {
      budgetMax: 620000,
      moveIn: '2026-09-01',
      kind: 'Shared apartment',
      roommateCount: 2,
      sleep: 'Early riser',
      tidiness: 'Very tidy',
      noise: 'Quiet',
      study: 'Library',
      smoking: 'No smoking',
      guests: 'Rarely',
      sharedShopping: false,
    },
  },
  {
    id: 'rm-3',
    displayName: 'Ifeoma E.',
    initials: 'IE',
    programme: 'B.Sc. Systems Engineering',
    level: '300 Level',
    bio: 'Same department, same timetable. I want somewhere with a proper study corner and reliable power.',
    contactShared: true,
    preferences: {
      budgetMax: 600000,
      moveIn: '2026-09-01',
      kind: 'Shared apartment',
      roommateCount: 2,
      sleep: 'Balanced',
      tidiness: 'Tidy',
      noise: 'Quiet',
      study: 'Mixed',
      smoking: 'No smoking',
      guests: 'Sometimes',
      sharedShopping: true,
    },
  },
  {
    id: 'rm-4',
    displayName: 'Kemi O.',
    initials: 'KO',
    programme: 'LL.B Law',
    level: '200 Level',
    bio: 'Social, in the drama society, often out in the evenings. Looking for three flatmates to keep costs down.',
    contactShared: false,
    preferences: {
      budgetMax: 400000,
      moveIn: '2026-10-01',
      kind: 'Shared apartment',
      roommateCount: 3,
      sleep: 'Night owl',
      tidiness: 'Relaxed',
      noise: 'Lively',
      study: 'Library',
      smoking: 'No smoking',
      guests: 'Often',
      sharedShopping: false,
    },
  },
  {
    id: 'rm-5',
    displayName: 'Daniel U.',
    initials: 'DU',
    programme: 'B.Sc. Computer Science',
    level: '300 Level',
    bio: 'Up late building side projects. Need good internet more than anything else.',
    contactShared: false,
    preferences: {
      budgetMax: 700000,
      moveIn: '2026-09-15',
      kind: 'Co-living',
      roommateCount: 2,
      sleep: 'Night owl',
      tidiness: 'Tidy',
      noise: 'Moderate',
      study: 'At home',
      smoking: 'No smoking',
      guests: 'Sometimes',
      sharedShopping: true,
    },
  },
  {
    id: 'rm-6',
    displayName: 'Aisha B.',
    initials: 'AB',
    programme: 'B.Pharm Pharmacy',
    level: '400 Level',
    bio: 'Early mornings at the teaching hospital. I keep shared spaces very clean and go to bed early.',
    contactShared: false,
    preferences: {
      budgetMax: 640000,
      moveIn: '2026-09-01',
      kind: 'Shared apartment',
      roommateCount: 2,
      sleep: 'Early riser',
      tidiness: 'Very tidy',
      noise: 'Quiet',
      study: 'Mixed',
      smoking: 'No smoking',
      guests: 'Rarely',
      sharedShopping: true,
    },
  },
  {
    id: 'rm-7',
    displayName: 'Segun F.',
    initials: 'SF',
    programme: 'B.Sc. Economics',
    level: '300 Level',
    bio: 'Plays five-a-side most evenings, otherwise around. Fine with a lively house.',
    contactShared: false,
    preferences: {
      budgetMax: 480000,
      moveIn: '2026-09-01',
      kind: 'Hostel',
      roommateCount: 3,
      sleep: 'Balanced',
      tidiness: 'Relaxed',
      noise: 'Lively',
      study: 'Library',
      smoking: 'Smoker friendly',
      guests: 'Often',
      sharedShopping: false,
    },
  },
]
